import { STORAGE_ENCRYPTION_KEY } from 'webconfig'
import CryptoHelper from "@/utils/CryptoHelper"

const GetSessionItem = (key) => {
    const encryptedData = sessionStorage.getItem(key)
    const decryptedData = CryptoHelper.AESDecrypt(encryptedData, STORAGE_ENCRYPTION_KEY)
    return decryptedData
}

const SetSessionItem = (key, data) => {
    const encryptedData = CryptoHelper.AESEncrypt(data, STORAGE_ENCRYPTION_KEY)
    sessionStorage.setItem(key, encryptedData)
}

export default {
    GetSessionItem,
    SetSessionItem
}